import { configureStore } from '@reduxjs/toolkit';
import componentssliceReducer from './slices/ComponentsSlice.js';
import documentsReducer from './slices/DocumentsSlice';
import equalizerReducer from './slices/EqualizerSlice';
import favoriteFlatsReducer from './slices/FavoriteFlatSlice.js';
import filterReducer from './slices/FilterSlice.js';
import flatReducer from './slices/FlatSlice.js';
import galleryReducer from './slices/GallerySlice';
import newsReducer from './slices/NewsSlice.js';
import parkingReducer from './slices/ParkingSlice.js';
import projectsliceReducer from './slices/ProjectSlice.js';
import termsReducer from './slices/TermsSlice.js';
import usersliceReducer from './slices/UserSlice';
import visualBulkReducer from './slices/VisualBulkSlice.js';
import visualFlatReducer from './slices/VisualFlatSlice.js';
import visualFloorReducer from './slices/VisualFloorSlice.js';
import visualReducer from './slices/VisualSlice';

const rootReducer = {
  componentsstate: componentssliceReducer,
  userinfo: usersliceReducer,
  projectinfo: projectsliceReducer,
  filters: filterReducer,
  favoriteFlats: favoriteFlatsReducer,
  flatInfo: flatReducer,
  termsInfo: termsReducer,
  documentsInfo: documentsReducer,
  newsInfo: newsReducer,
  galleryInfo: galleryReducer,
  visual: visualReducer,
  visualFloor: visualFloorReducer,
  visualFlat: visualFlatReducer,
  equalizer: equalizerReducer,
  visualBulk: visualBulkReducer,
  parking: parkingReducer,
};

const defaultMiddleware = getDefaultMiddleware =>
  getDefaultMiddleware({
    serializableCheck: false,
    immutableCheck: false,
  });

export function makeStore(preloadedState) {
  return configureStore({
    reducer: rootReducer,
    middleware: defaultMiddleware,
    devTools: process.env.NODE_ENV === 'development',
    ...(preloadedState != null ? { preloadedState } : {}),
  });
}

export const store = makeStore();
